import { IUserInvoice } from 'src/entities/user';
import { ifFalseThenRequired, isValidLength, IValidationRule, required } from './validations';

const getInvoiceDetailsFields = () => {
    const nameField: keyof IUserInvoice = 'InvoiceName';
    const countryField: keyof IUserInvoice = 'Country';
    const cityField: keyof IUserInvoice = 'City';
    const steetAddressField: keyof IUserInvoice = 'StreetAddress';
    const postalCodeField: keyof IUserInvoice = 'PostalCode';
    const privatePersonField: keyof IUserInvoice = 'PrivatePerson';
    const taxNumberField: keyof IUserInvoice = 'TaxNumber';

    return {        
        InvoiceName: nameField,
        Country: countryField,
        City: cityField,
        StreetAddress: steetAddressField,
        PostalCode: postalCodeField,
        PrivatePerson: privatePersonField,
        TaxNumber: taxNumberField,
    }
}

export const invoiceDetailsFields = getInvoiceDetailsFields();

export const invoiceDetailsRules = () : IValidationRule[] => {
    const rules = [
        required(invoiceDetailsFields.InvoiceName),
        required(invoiceDetailsFields.Country),
        required(invoiceDetailsFields.City),
        required(invoiceDetailsFields.StreetAddress),
        required(invoiceDetailsFields.PostalCode),

        ifFalseThenRequired(invoiceDetailsFields.TaxNumber, invoiceDetailsFields.PrivatePerson),

        isValidLength(invoiceDetailsFields.InvoiceName, undefined, 256),
        isValidLength(invoiceDetailsFields.Country, undefined, 2),
        isValidLength(invoiceDetailsFields.City, undefined, 50),
        isValidLength(invoiceDetailsFields.StreetAddress, undefined, 150),
        isValidLength(invoiceDetailsFields.PostalCode, 2, 16),
        isValidLength(invoiceDetailsFields.TaxNumber, undefined, 15)
    ];

    return rules;
} 